module.exports = __webpack_public_path__ + "media/sub2-7-3.b39e4298.mp4";